import { Component, Input, Pipe, PipeTransform, Injector } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'corrispondenza_2',
  templateUrl: 'corrispondenza_2.html',
})

export class Corrispondenza_2Component extends Domanda_super {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  domandapari: any = [];
  iselect_opened = [];
  risptesto: any = [];
  risposte_conferma = [];
  showconferma: boolean = true;
  showfeed: boolean = false;
  showtime: boolean = true;
  feed = '';
  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
    this.output = 'test string';

  }
  ngOnInit() {
    this.events.publish('start_tempo', this.domanda);
    //console.log('asdf', this.domanda);
    var risp_aux = [];
    for (var i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
      this.risptesto[i] = { testo: '' };
      if (i % 2 != 0) {//manca lo shuffle
        risp_aux.push(this.domanda['RispostaMicroStepList'][i]);
        //this.domandapari.push(this.domanda['RispostaMicroStepList'][i]);
      }
      else {
        this.iselect_opened[i] = false;

      }
    }
    if (this.settingsmq.risposteCausali == '1')
      this.domandapari = this.shuffle(risp_aux);
    else
      this.domandapari = risp_aux;

    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });

  }

  openselect(i) {
    if (!this.showconferma)
      return;
    for (let g = 0; g < this.iselect_opened.length; g++) {
      if (this.iselect_opened[g] == true)
        return;
    }

    /*if (this.risptesto[i].testo != '')
      this.domandapari.unshift(this.risptesto[i]);
*/
    //console.log(this.iselect_opened);
    this.iselect_opened[i] = true;
  }
  sel(r, i) {
    if (!this.showconferma)
      return;
    //this.domandapari.splice(this.domandapari.indexOf(r), 1);
    for (let f = 0; f < this.risptesto.length; f++) {
      if (this.risptesto[f].id == r.id)
        this.risptesto[f] = { 'testo': '' };
    }

    //console.log(r);
    this.iselect_opened[i] = false;
    this.risptesto[i] = r;
    let risposte_output = [];

    this.risptesto.forEach(element => {
      if (element.id != undefined)
        risposte_output.push(element.id);
    });
    //this.update_output(risposte_output);
    this.risposte_conferma = risposte_output;

  }
  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('corrispondenza', this.domanda, this.risposte_conferma);
  }
  position_class(h, len) {
    if (h == 0) {
      return 'first';
    }
    else if (h == len - 1)
      return 'last';
    else
      return '';
  }
  conferma(tempo?) {
    this.translate.get('domande.ERRRISPOSTE').subscribe(v => {
      if (this.risposte_conferma.length != this.domandapari.length && tempo != 'tempo') {
        // this.feed = 'Devi inserire tutte le risposte';
        // this.showfeed = true;
        this.presentToast(v);
        return;
      }

      this.events.publish('stop_tempo_parziale', this.domanda);
      let errate = [];
      let esatte = [];
      var h = 0;
      for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
        let r = this.domanda['RispostaMicroStepList'][i];
        if (i % 2 != 0 && this.risposte_conferma[h] == r.id) {
          esatte.push(this.risposte_conferma[h]);
          h++;
        }

        else if (i % 2 != 0 && this.risposte_conferma[h] != r.id) {
          errate.push(this.risposte_conferma[h]);
          h++;
        }
      }
      //console.log('esatte', esatte);
      //console.log('errate', errate);
      if (!this.settingsmq['istest'])
        this.changestyle(esatte, errate);
      if (errate.length == 0)
        this.feed = this.domanda['feedbackPositivo'];
      else if (esatte.length > 0)
        this.feed = this.domanda['feedbackParziale'];
      else
        this.feed = this.domanda['feedbackNegativo'];


      this.showconferma = false;
      this.showfeed = true;
      if (this.settingsmq['istest'])
        this.prosegui();
    });
  }

  changestyle(esatte, errate) {
    var x = document.getElementsByClassName("button_question");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];

      if (esatte.indexOf(l['id']) != -1) {
        l.classList.add('green');
      }
      else if (errate.indexOf(l['id']) != -1) {
        l.classList.add('red');
      }
    }
  }


  clone(obj) {
    let copy = (JSON.parse(JSON.stringify(obj)));
    return copy;
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/corrispondenza_2.ts